import React from 'react';
import { useTranslation } from 'react-i18next';
import { CollectCounts, CollectTab } from '../../types';
import * as Styled from './CollectTabs.styles';

interface CollectTabsProps {
  activeTab: CollectTab;
  counts: CollectCounts;
  onChange: (tab: CollectTab) => void;
}

const TAB_CONFIG: Record<CollectTab, { labelKey: string; icon: string }> = {
  [CollectTab.PENDING]: {
    labelKey: 'OrderPage.Collect.Tabs.PENDING',
    icon: '⏳',
  },
  [CollectTab.DONE]: { labelKey: 'OrderPage.Collect.Tabs.DONE', icon: '✅' },
  [CollectTab.PROBLEMS]: {
    labelKey: 'OrderPage.Collect.Tabs.PROBLEMS',
    icon: '⚠️',
  },
};

const CollectTabs = ({ activeTab, counts, onChange }: CollectTabsProps) => {
  const { t } = useTranslation();

  return (
    <Styled.TabsWrapper>
      <Styled.TabsContainer>
        {Object.values(CollectTab).map((tab) => (
          <button
            key={tab}
            type="button"
            className={`tab-button ${activeTab === tab ? 'active' : ''}`}
            onClick={() => onChange(tab)}
          >
            <span className="tab-icon">{TAB_CONFIG[tab].icon}</span>
            {t(TAB_CONFIG[tab].labelKey)}
            <span className="tab-count">{counts[tab]}</span>
          </button>
        ))}
      </Styled.TabsContainer>
      <Styled.TabHint>
        {t(`OrderPage.Collect.TabHints.${activeTab.toUpperCase()}`)}
      </Styled.TabHint>
    </Styled.TabsWrapper>
  );
};

export default CollectTabs;
